import "./tab.js";

// Looks to the DOM to provide tab navigation services for elements already on the page
// tabNavigationContainerSelector should select the container that holds both the navigation, and the content
class TabManager {
  constructor(tabNavigationContainerSelector, options) {
    this.tabNavigationContainer = jQuery(tabNavigationContainerSelector);
    this.options = jQuery.extend(
      {
        navigationSelector: ".tab-selectors",
        contentContainerSelector: ".tab-content-container",
        disabledTabsIDs: [], // Strings of tab IDs
      },
      options,
    );

    this.tabs = [];
    this.selectedTab;
    this.tabNavigation = this.tabNavigationContainer.find(this.options.navigationSelector);
    this.tabContentContainer = this.tabNavigationContainer.find(this.options.contentContainerSelector);
    this.tabHistoryMethod = this.tabNavigation.closest("[data-history]").data("history");

    this._setupEvents();
    this._collectTabs();

    if (this.options.disabledTabsIDs.length > 0) {
      if (!Array.isArray(this.options.disabledTabsIDs)) {
        this.options.disabledTabsID = [this.options.disabledTabsID];
      }
      this._disableTabs(this.options.disabledTabsIDs);
    }

    this._showInitalTab();
  }

  // Events
  _setupEvents() {
    this.tabNavigationContainer.on("tab:selected", "input:radio[data-behaviour=tabstate]", (e) => {
      this._tabSelectHandler(e);
    });
  }

  _tabSelectHandler(e) {
    const findTab = this._findTabById(jQuery(e.currentTarget).attr("id"));
    if (findTab.disabled) {
      e.stopPropagation();
      this._showInitalTab();
    }
  }

  // Helpers

  setDisabled(id) {
    try {
      const findTab = this._findTabById(id);
      findTab.disabled = true;
      if (findTab.selected) {
        findTab.hide();
        this._showFirstAvailableTab();
      }
    } catch (e) {
      console.warn(e);
    }
  }

  isDisabled(id) {
    try {
      const findTab = this._findTabById(id);
      return findTab.disabled;
    } catch (e) {
      console.warn(e);
      return null;
    }
  }

  isNeedy(id) {
    try {
      const findTab = this._findTabById(id);
      return findTab.isNeedy;
    } catch (e) {
      console.warn(e);
      return null;
    }
  }

  // Private

  _collectTabs() {
    this.tabNavigation.find("input:radio[data-behaviour=tabstate]").each((i, node) => {
      const tabSelector = jQuery(node);
      const tabContent = this.tabContentContainer.find(`#${tabSelector.attr("aria-controls")}`);
      const tab = new Tab(tabSelector, tabContent);
      tab.hide();
      this.tabs.push(tab);
    });
  }

  _disableTabs(array) {
    array.forEach((tabID) => {
      this.setDisabled(tabID);
    });
  }

  _showInitalTab() {
    let isNeedyTabSet = false;
    this.tabs.forEach((tab) => {
      if (tab.selected || (tab.isNeedy && !tab.disabled && isNeedyTabSet == false)) {
        if (tab.disabled) {
          return;
        }
        if (tab.needyTab) {
          isNeedyTabSet = true;
        }
        this.selectedTab = tab;
      }
    });

    if (this.selectedTab === false || this.selectedTab === undefined) {
      this._showFirstAvailableTab();
    } else {
      this.selectedTab.show(true);
    }
  }

  _showFirstAvailableTab() {
    this.selectedTab = null;
    this.tabs.forEach((tab) => {
      if (this.selectedTab !== null || tab.disabled) {
        return;
      }
      tab.show(true); // show first available tab if none are selected
      this.selectedTab = tab;
    });
  }

  _findTabById(id) {
    id = String(id);
    const findTab = this.tabs.find((tab) => tab.id === id);

    if (findTab) {
      return findTab;
    } else {
      throw "Unable to find tab with id of " + id;
    }
  }
}

window.TabManager = TabManager;
